import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    cortesDeCaja: [],
    objetoInfoCorteDeCajaSucursal: {},
  },
  mutations: {

    destroyCortesDeCaja(state) {
      state.cortesDeCaja = [];
      state.objetoInfoCorteDeCajaSucursal = {};
    },
    getCortesDeCaja(state, datos) {
      state.cortesDeCaja = datos.DATOS;
      state.paginacionCortesDeCaja = datos.INFO.paginacion.Paginas;
    },
    getEfectivoCaja(state, datos) {
      state.objetoInfoCorteDeCajaSucursal = datos;
    },

  },
  actions: {
    async destroyCortesDeCaja({ commit }) {
      commit('destroyCortesDeCaja');
    },
    async getCortesDeCaja({
      commit,
    }, cut) {
      try {
        const res = await api.getCortesDeCaja(cut);
        // console.log(object);
        if (res.data.DATOS) {
          commit('getCortesDeCaja', res.data);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getCortesDeCajaAgrupado({
      commit,
    }, cut) {
      try {
        const res = await api.getCortesDeCajaAgrupado(cut);
        // console.log(object);
        if (res.data.DATOS) {
          commit('getCortesDeCaja', res.data);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getEfectivoCaja({
      commit,
    }, cut) {
      try {
        const res = await api.getEfectivoCaja(cut);
        // console.log(object);
        if (res.data.DATOS) {
          commit('getEfectivoCaja', res.data.DATOS[0]);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async hacerCorteDeCaja({
      commit,
    }, cut) {
      try {
        const res = await api.hacerCorteDeCaja(cut);
        // console.log(object);
        if (res.data.INFO.cod == 200) {
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },



  },
};
